import React from 'react'

import Base from '../_Base'

const Star = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M15.266,8.352 L11.9878699,1.7230412 L8.73,8.352 L1.43129568,9.3974016 L6.71,14.528 L5.4647669,21.848604 L11.999,18.39 L18.5439334,21.8495737 L17.285,14.528 L22.570262,9.39753908 L15.266,8.352 Z M10.0591622,10.1825958 L11.993,6.245 L13.9407436,10.1828508 L18.254,10.8 L15.136337,13.8274523 L15.884,18.181 L11.9997709,16.1277596 L8.116,18.182 L8.85795328,13.8270784 L5.743,10.8 L10.0591622,10.1825958 Z" />
  </Base>
)

export default Star
